<template>
  <div class="navbar">
    <div class="breadcrumb">
      <!--      <hamburger-->
      <!--        :is-active="sidebar.opened"-->
      <!--        class="hamburger-container"-->
      <!--        @toggleClick="toggleSideBar" />-->

      <!--      <breadcrumb class="breadcrumb-container" />-->

      <div class="right-menu">
        <el-dropdown class="avatar-container" trigger="click">
          <div class="avatar-wrapper">
            <el-avatar
              shape="square"
              :src="avatar"
              class="avatarM"
              v-if="
                avatar !== '' && avatar != null && avatar != undefined
              "></el-avatar>
            <img :src="styleTheme.avatar" class="avatarM" v-else />
            <span class="spanM" id="spanId">
              {{ name }}
              <div class="spanMDiv">
                <el-switch
                  :value="themeSelect === '1' ? true : false"
                  @click.native.stop="changeTheme" />
              </div>
            </span>
            <div class="divM" id="divMId">
              <i class="el-icon-caret-bottom" />
            </div>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <router-link to="/">
              <el-dropdown-item>回到首页</el-dropdown-item>
            </router-link>
            <el-dropdown-item divided @click.native="signout">
              <span style="display: block">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
// import { getToken, setToken, removeToken } from '@/utils/auth'
// import { resetRouter } from '@/router'
// import { userLogout } from '@/api/user'
export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "name", "menuTabs"]),
    activeMenuTab: {
      get() {
        return this.$store.getters.activeMenuTab;
      },
      set() {},
    },
  },
  data() {
    return {
      menu: {
        show: false,
        position: { left: "0px", top: "0px" },
        currentIndex: 0,
        leftShow: false,
        rightShow: false,
      },
      contextMenuVisible: false,
      youjianPath: "",
      theme1: "1",
      themeSelect: "1",
      radioSelect: "1",
      radio1: "1",
    };
  },
  watch: {
    ...mapGetters(["sidebar"]),
    "sidebar.opened": {
      handler(newValue, oldValue) {
        this.menu.show = false;
      },
      deep: true,
    },
    contextMenuVisible() {
      //监听 右键关闭菜单 点击任何地方 菜单消失
      if (this.contextMenuVisible) {
        document.body.addEventListener("click", this.closeMenu);
        if (this.$el(l.contains(event.target))) {
        } else {
          this.menu.show = false;
        }
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  created() {
    var _this = this;
    document.addEventListener("click", function (event) {
      let tabsArea = document.getElementById("el_tabs_container");
      let tabPopArea = document.getElementById("tabs_pop_area");
      if (tabsArea && tabsArea.contains(event.target)) {
      } else {
        if (tabPopArea && tabPopArea.contains(event.target)) {
        } else {
          _this.menu.show = false;
        }
      }
    });
  },
  mounted() {
    //给tab绑定右击事件
    // let tab_top_dom = document.getElementsByClassName("el-tabs__header is-top");
    // tab_top_dom[0].oncontextmenu = this.openContextMenu;
    this.initThem();
  },
  methods: {
    ...mapActions("user", ["logout"]),
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    initThem() {
      console.log("走咳咳咳咳咳 ");
      var theme = localStorage.getItem("theme");
      var bgPageTheme = "";
      var contentPageTheme = localStorage.getItem("contentPageTheme");
      var sliderBg = "";
      var styleTheme = localStorage.getItem("m-style");
      var changeHeaderKuangPageTheme = localStorage.getItem(
        "headerKuangPageTheme"
      );
      console.log("背景主题" + styleTheme);
      if (styleTheme) {
        this.$store.dispatch("Theme/changeStyleTheme", styleTheme);
        this.radioSelect = styleTheme;
        this.themeSelect = styleTheme;
        console.log(
          "main-container-id" + document.getElementById("main-container-id")
        );
        if (styleTheme + "" === "1") {
          sliderBg = "#202020";
          document.body.classList = [];
          if (document.getElementById("main-container-id") != null) {
            document.getElementById("main-container-id").classList = [];
            document.getElementById("main-container-id").classList = [
              "main-container",
            ];
          }
          if (document.getElementById("spanId") != null) {
            document.getElementById("spanId").classList = [];
            document.getElementById("spanId").classList = ["spanM"];
          }
          if (document.getElementById("divMId") != null) {
            document.getElementById("divMId").classList = [];
            document.getElementById("divMId").classList = ["divM"];
          }
          Array.prototype.forEach.call(document.getElementsByClassName("el-scrollbar"), (item) => {
            item.style =
              "width:calc(100% - 24px);height:calc(100% - 84px);margin-left: 24px;";
          });
          document.body.classList = [];
          document.body.classList.add("theme-maomao-class");
          bgPageTheme = "#202020";
        } else if (styleTheme + "" === "2") {
          sliderBg = "#304156";
          if (document.getElementById("main-container-id") != null) {
            document.getElementById("main-container-id").classList = [];
            document.getElementById("main-container-id").classList = [
              "main-container-1",
            ];
          }
          if (document.getElementById("spanId") != null) {
            document.getElementById("spanId").classList = [];
            document.getElementById("spanId").classList = ["spanM1"];
          }
          if (document.getElementById("divMId") != null) {
            document.getElementById("divMId").classList = [];
            document.getElementById("divMId").classList = ["divM1"];
          }
          document.body.classList = [];
          document.body.classList.add("theme-maomao-class-1");
          bgPageTheme = "#f5f5f5";

          Array.prototype.forEach.call(document.getElementsByClassName("el-scrollbar"), (item) => {
            item.style = "width:100%;height:100%;margin-left:0;";
          });
        }
        console.log("背景主题" + bgPageTheme);
        // await _this.$changeBgPageTheme(bgPageTheme);
        console.log("背景主题-----------------------");
        Array.prototype.forEach.call(document.getElementsByClassName("sidebar-container"), (item) => {
          item.style =
            "background-color:" + styleTheme + "" === "2"
              ? "#121212"
              : sliderBg + ";";
        });
      } else {
        this.themeSelect = "1";
        this.changeAllTheme();
      }
    },
    changeTheme() {
      this.themeSelect = this.themeSelect === "1" ? "2" : "1";
      this.changeAllTheme();
    },
    async changeAllTheme() {
      localStorage.setItem("m-style", this.themeSelect);
      var sliderBg = "";
      var bgPageTheme = "";
      this.$store.dispatch("Theme/changeStyleTheme", this.themeSelect);
      console.log(
        "main-container-id" + document.getElementById("main-container-id")
      );
      if (this.themeSelect + "" === "1") {
        sliderBg = "#202020";
        document.body.classList = [];
        if (document.getElementById("main-container-id") != null) {
          document.getElementById("main-container-id").classList = [];
          document.getElementById("main-container-id").classList = [
            "main-container",
          ];
        }
        if (document.getElementById("spanId") != null) {
          document.getElementById("spanId").classList = [];
          document.getElementById("spanId").classList = ["spanM"];
        }
        if (document.getElementById("divMId") != null) {
          document.getElementById("divMId").classList = [];
          document.getElementById("divMId").classList = ["divM"];
        }
        Array.prototype.forEach.call(document.getElementsByClassName("el-scrollbar"), (item) => {
          item.style =
            "width:calc(100% - 24px);height:calc(100% - 84px);margin-left: 24px;";
        });
        document.body.classList = [];
        document.body.classList.add("theme-maomao-class");
        bgPageTheme = "#202020";
      } else {
        sliderBg = "#304156";
        if (document.getElementById("main-container-id") != null) {
          document.getElementById("main-container-id").classList = [];
          document.getElementById("main-container-id").classList = [
            "main-container-1",
          ];
        }
        if (document.getElementById("spanId") != null) {
          document.getElementById("spanId").classList = [];
          document.getElementById("spanId").classList = ["spanM1"];
        }
        if (document.getElementById("divMId") != null) {
          document.getElementById("divMId").classList = [];
          document.getElementById("divMId").classList = ["divM1"];
        }
        document.body.classList = [];
        document.body.classList.add("theme-maomao-class-1");
        bgPageTheme = "#f5f5f5";

        Array.prototype.forEach.call(document.getElementsByClassName("el-scrollbar"), (item) => {
          item.style = "width:100%;height:100%;margin-left:0;";
        });
      }
      console.log("背景主题" + bgPageTheme);
      // await _this.$changeBgPageTheme(bgPageTheme);
      console.log("背景主题-----------------------");
      Array.prototype.forEach.call(document.getElementsByClassName("sidebar-container"), (item) => {
        item.style =
          "background-color:" + this.themeSelect + "" === "2"
            ? "#121212"
            : sliderBg + ";";
      });
    },
    signout() {
      this.logout(this);
    },
    // 关闭页签
    handleClose(name) {
      if (this.menuTabs.length === 1) return;
      if (this.activeMenuTab === name) {
        console.log(this.menuTabs);
        const arr = this.menuTabs.map((item) => {
          return item;
        });
        let index = arr.findIndex((item) => {
          return item.path === name;
        });
        arr.splice(index, 1);
        console.log(index);
        console.log(arr);
        index = index > 0 ? index : 1;
        this.$router.push({ path: arr[index - 1].path });
        this.$store.commit("user/SET_MENU_TABS", [...arr]);
      } else {
        console.log(this.menuTabs);
        const arr = this.menuTabs;
        let index = arr.findIndex((item) => {
          return item.path === name;
        });
        arr.splice(index, 1);
        console.log(index);
        this.$store.commit("user/SET_MENU_TABS", [...arr]);
      }
    },
    tabClick(tab) {
      console.log(tab);
      this.$router.push({ path: tab.name });
    },
    closeAllLeft() {
      if (this.menuTabs.length === 1) return;
      this.menuTabs.splice(0, this.menu.currentIndex);
      this.menu.show = false;
      let index = this.menuTabs.findIndex((item) => {
        return item.path === this.activeMenuTab;
      });
      if (index > 0) {
      } else {
        this.$router.push({
          path: this.menuTabs[this.menuTabs.length - 1].path,
        });
      }

      this.$store.commit("user/SET_MENU_TABS", [...this.menuTabs]);
    },
    closeAllRight() {
      if (this.menuTabs.length === 1) return;
      this.menuTabs.splice(this.menu.currentIndex + 1);
      this.menu.show = false;
      let index = this.menuTabs.findIndex((item) => {
        return item.path === this.activeMenuTab;
      });
      if (index > 0) {
      } else {
        this.$router.push({
          path: this.menuTabs[this.menuTabs.length - 1].path,
        });
      }
      this.$store.commit("user/SET_MENU_TABS", [...this.menuTabs]);
    },
    closeAll() {
      var name = this.youjianPath;
      console.log("除了" + name + "不关闭都关闭");
      console.log(name);

      if (this.menuTabs.length === 1) return;

      //如果右击的是其他菜单
      const arr = this.menuTabs;
      var pathList = arr.filter((item) => {
        return item.path == name;
      });
      this.menu.show = false;
      this.$router.push({
        path: pathList[0].path,
      });
      this.$store.commit("user/SET_MENU_TABS", [...pathList]);
    },

    //显示右击菜单（关闭所有）
    openContextMenu(e) {
      e.preventDefault();
      var _this = this;
      if (_this.menuTabs.length === 1) return;
      console.log(e.srcElement.id.split("tab-")[1]);

      const currentIndex = this.menuTabs.findIndex(
        (tab) => tab.path === e.srcElement.id.split("tab-")[1]
      );
      //算出有没有左
      if (currentIndex == 0) {
        this.menu.leftShow = false;
      } else {
        this.menu.leftShow = true;
      }
      //有没有右侧
      if (currentIndex == this.menuTabs.length - 1) {
        this.menu.rightShow = false;
      } else {
        this.menu.rightShow = true;
      }

      console.log(e.clientY);
      this.menu.position = {
        left: `${e.clientX}px`,
        top: `5rem`,
      };
      this.menu.currentIndex = currentIndex;
      this.menu.show = true;
      this.youjianPath = e.srcElement.id.split("tab-")[1];
    },
    //隐藏菜单
    closeMenu() {
      this.contextMenuVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-wrapper-theme {
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}
.block_colors {
  padding: 0 20px;
}
.block_color {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    margin-bottom: 20px;
  }
}
.el-tag.el-tag--warning {
  font-weight: bold;
}
.noticeText {
  margin-right: 20px;
}
.custom-contextmenu {
  position: fixed;
  background: white;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 9999;
}

.custom-contextmenu div {
  padding: 8px 16px;
  cursor: pointer;
  font-size: 12px;
}

.custom-contextmenu div:hover {
  background: #f5f7fa;
}
.navbar {
  height: 84px;
  overflow: hidden;
  position: relative;
  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .menu-tab-box {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-start;
    .menu-tab-item {
      flex: 1;
      max-width: 100px;
      overflow: hidden;
      ::v-deep .el-icon-close {
        width: 23px;
      }
    }
  }
  .breadcrumb {
    height: 50px;
  }
  .hamburger-container {
    line-height: 46px;
    // height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    height: 100%;
    float: right;
    display: flex;
    align-items: end;
    .company-name {
      margin-right: 10px;
    }
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 9px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: end;
        .avatar-area {
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.hide ::v-deep .el-upload--picture-card {
  display: none;
}
</style>
